<template>
  <header
    v-if="postObj"
    class="SubjectAreaHeaderComp"
    :key="`subject-area-${postObj.id}`"
    :class="headerClasses"
  >
    <!-- Left-col -->
    <div :class="headerColClasses">
      <div class="lg:pr-7">
        <!-- Heading -->
        <Heading
          v-if="headingText"
          :class="`mb-4 last:mb-0 text-${headingColor}`"
          large
          :text="headingText"
        />
        <!-- Body text -->
        <div
          v-if="postObj.body"
          class="tiny-mce"
          v-html="wysiwygFilter(postObj.body)"
        />
        <!-- Main Call-to-action -->
        <div
          v-if="btnObj.url && btnObj.text"
          class="mt-5"
        >
          <MultiBtn
            :url="utmHref(btnObj.url, 'tier-2-cta')"
            icon="external-link"
            :theme="buttonStyle"
            :text="btnObj.text"
            :label="btnObj.title"
          />
        </div>
      </div>
    </div>
    <!-- Right-col -->
    <div
      v-if="featuredContent"
      :class="headerColClasses"
    >
      <Card
        :post-obj="featuredContent"
        full-width
      />
    </div>
  </header>
</template>

<script>
import Heading from '@/components/text/Heading.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import Card from '@/components/buttons/Card.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SubjectAreaHeader',

  components: {
    Heading,
    SvgIcon,
    MultiBtn,
    Card,
  },

  props: {
    postObj: {
      type: Object,
      default: () => {}
    },
    headingText: {
      type: String,
      default: ''
    },
  },

  computed: {
    // Data
    ...mapState([]),
    ...mapGetters([ 'myStore' ]),
    // Btn
    // Header
    headerClasses() {
      return [
        'max-w-68 sm:max-w-136 lg:max-w-204 xl:max-w-272',
        'mx-auto mb-5 lg:mb-7',
        'flex flex-wrap'
      ]
    },
    use2Col() { },
    headerColClasses() {
      const lgWidth = this.featuredContent ? 'lg:w-1/2' : ''
      return [
        'w-full',
        lgWidth,
        'px-2',
        'mb-7 last:mb-0 lg:mb-0'
      ]
    },
    // Heading
    headingColor() { return this.myStore(['styles', 'global', 'heading', 'text_color']) ?? 'accent-1' },
    // Main Call-to-action
    btnObj() {
      const btnObj = this.postObj.main_cta ?? {}
      return {
        url: btnObj.url,
        text: btnObj.btn_text,
        title: btnObj.btn_title || btnObj.btn_text,
        icon: btnObj.btn_icon || 'external-link'
      }
    },
    buttonStyle() { return this.myStore(['styles', 'subject_areas', 'single', 'main_cta', 'button_style']) ?? 'button_style_1' },
    // Featured Content
    featuredContent() {
      const featuredOrVideo = this.postObj.featuredContent || this.postObj.mainVideo
      const fcObj = featuredOrVideo && { ...featuredOrVideo }
      if (!fcObj) { return }
      fcObj.routeTo = {
        name: 'aoi-media',
        params: { media_id: fcObj.slug }
      }
      return fcObj
    }
  },
}
</script>

